export default "__VITE_ASSET__B3e_uwJ4__"